export default __webpack_public_path__ + "static/media/weather-sm.c724d204.png";